const store = new Map<string, boolean>();

export const loadStyle = ({ href }: { href: string }): Promise<void> => {
  if (store.get(href)) {
    return Promise.resolve();
  }

  store.set(href, true);

  return new Promise((resolve, reject) => {
    try {
      const link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = href;

      link.addEventListener('load', () => {
        resolve();
      });

      link.addEventListener('error', () =>
        reject(new Error(`Failed to load style with src ${href}`))
      );

      document.head.appendChild(link);
    } catch (error) {
      reject(error);
    }
  });
};
